import { useAppSelector } from '@frontend/common';
import { EquipmentStateConstraintData, isEquipmentStateConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { EquipmentStateConstraintDataInputProps } from './equipment-state-constraint-data-input.component';

interface ViewProps {
    formValues: EquipmentStateConstraintData;
}

const useEquipmentStateConstraintDataInput = (props: EquipmentStateConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isEquipmentStateConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { state: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useEquipmentStateConstraintDataInput;
